<template>
  <div>
    <Header :self="self" />
    <div class="container wide">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <div>
        <div class="text-center">
          <h3>Like Quozio? You'll &#10084;&#65039; Quozio Pro!</h3>
        </div>

        <div class="col-12">
          <button class="btn btn-success btn-lg get-quozio-pro" @click="checkout('A')" :disabled="submitting.createCheckoutSession">Get Quozio Pro <div class="sub">$29 / year</div></button>
        </div>

        <div class="row my-3 content-box">
          <div class="col-md col-12 order-sm-last order-md-0">
            <h4>Create your own custom designs</h4>
            Unleash your creativity by creating your own, custom quote designs with millions of background images, hundreds of fonts, adjustable filters, text colors, shapes and more. With unlimited possibilities, you can effortlessly design stunning custom creations in just seconds. No need to worry about a learning curve, just click, tap, and snap! Your creation is complete!
          </div>
          <div class="col-md col-12">
            <img src="/images/get-quozio-pro/create-your-own-designs.jpg" class="feature-image" />
          </div>
        </div>

        <div class="row content-box">
          <div class="col-md col-12 order-last order-sm-0">
            <img src="/images/get-quozio-pro/additional_templates.jpg" class="feature-image" />
          </div>
          <div class=" col-md col-12 ">
            <h4>Hundreds of additional pre-made designs</h4>
            Elevate your quote designs with hundreds of our premium hand-crafted backgrounds and templates. Enjoy frequent updates for endless inspiration. We've done the work for you, just pick your favorite!
          </div>
        </div>

        <div class="row my-3 content-box">
          <div class="col-md col-12 order-sm-last order-md-0">
            <h4>Add a personal watermark</h4>
            Create awesome quotes on Quozio and stamp them with your name, website, hashtag or social media handle before sharing. Make sure that those that see your creations know it came from you!
          </div>
          <div class=" col-md col-12 ">
            <img src="/images/get-quozio-pro/custom_watermark.png" class="feature-image" />
          </div>
        </div>

        <div class="row content-box">
          <div class="col-md col-12 order-last order-sm-0">
            <img src="/images/get-quozio-pro/poster.jpg" class="feature-image" />
          </div>
          <div class="col-md col-12">
            <h4>Download high definition, full size copies of your quotes</h4>
            Download high definition or larger images of the quotes you create. These full resolution versions are only available to Quozio Pro users and are generated with minimal compression in a large image format, perfect
            for printing, scrapbooking, adding to presentations, and more.
          </div>
        </div>

        <div class="row my-3 content-box">
          <div class="col-md col-12 order-sm-last order-md-0">
            <h4>Create Unlimited Boards</h4>
            Create as many public and private boards as you would like to keep and organize your favorite quotes.
          </div>
          <div class=" col-md col-12 ">
            <img src="/images/get-quozio-pro/boards.jpg" class="feature-image" />
          </div>
        </div>

        <div class="row content-box">
          <div class="col-md col-12 order-last order-sm-0">
            <img src="/images/get-quozio-pro/support.jpg" class="feature-image" />
          </div>
          <div class="col-md col-12">
            <h4>Premium Support</h4>
            Need a little extra help with Quozio? Want some tips for creating or sharing your quotes on social media? Looking for a bit of guidance on how to post a quote to your blog or website? Got an idea for a background or style you want us to create? With premium support, we've got you covered.
          </div>
        </div>

        <div class="col-12">
          <button class="btn btn-success btn-lg get-quozio-pro" @click="checkout('B')" :disabled="submitting.createCheckoutSession">Get Quozio Pro <div class="sub">$29 / year</div></button>
        </div>

      </div>
    </div>
    <Footer />
  </div>
</template>

<style>

  .content-box {
    padding: 12px;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .feature-image {
    width: 100%;
  }
</style>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";

  export default {
    name: "App",
    components: { Header, Footer },
    data() {
      return {
        error: null,
        isStripeLoaded: false,
        submitting: { createCheckoutSession: false },
      }
    },
    head() {
      return {
        title: "Get Quozio Pro",
        script: [
          {
            hid: "stripe",
            src: "https://js.stripe.com/v3/",
            defer: true,
            callback: () => { this.isStripeLoaded = true }
          }
        ]
      }
    },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    async mounted() {
      this.$ga.event("GetQuozioPro", "Get Quozio Pro - View Features", !(this.self.userId == null));
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
    methods: {
      async checkout(buttonId) {

        // If the user is not logged in or does not have an account, send to the signup page.
        if (!this.self || !this.self.userId) {
          this.$ga.event("GetQuozioPro", "Get Quozio Pro - Create Account", buttonId);
          this.$router.push({ name: "join", query: { then: "get-quozio-pro", ref: this.$route.query.ref } });
          return;
        }

        this.$ga.event("GetQuozioPro", "Get Quozio Pro - Load Checkout", buttonId);

        this.submitting.createCheckoutSession = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post("/payments/create-checkout-session", { meta: { ref: this.$route.query.ref } });
        this.$nuxt.$loading.finish();
        if (response.error) {
          this.error = response.error;
          this.submitting.createCheckoutSession = false;
          return;
        }

        // Redirect to the checkout page.
        var stripe = Stripe(this.$config.STRIPE_PUBLIC_API_KEY);
        stripe.redirectToCheckout({ sessionId: response.data.id });

      },
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
  };
</script>
